/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FrontendSiteSettings } from './FrontendSiteSettings';
import { ReleaseInfo } from './ReleaseInfo';
const BaseAboutParser = /* #__PURE__ */ parsers.object([
    ['commit', codecString],
    ['settings', FrontendSiteSettings],
    ['release', ReleaseInfo],
    ['currentTime', parsers.moment, 'current_time'],
]);
export class BaseAbout extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseAboutParser.decode(input).map(res => new BaseAbout(res));
    }
    static unsafeDecode(input) {
        return BaseAbout.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseAboutParser.encode(data);
    }
    static schema() {
        return BaseAboutParser.schema();
    }
}
